import React from 'react'
import { Package, Plus, Filter } from 'lucide-react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

export const Items: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Items Management</h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">Manage your product catalog and inventory items</p>
        </div>
        <Button><Plus className="w-4 h-4 mr-2" />Add Item</Button>
      </div>
      <Card>
        <CardContent className="pt-6">
          <div className="flex gap-4">
            <Input placeholder="Search items..." className="flex-1" />
            <Button variant="outline"><Filter className="w-4 h-4 mr-2" />Filter</Button>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Package className="w-5 h-5" />Items Catalog
          </CardTitle>
          <CardDescription>Product inventory and item management</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12">
            <Package className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium mb-2">Items Management</h3>
            <p className="text-gray-600 dark:text-gray-400 mb-4">Comprehensive product catalog system</p>
            <Button variant="outline">Learn More</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
